import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import WarningList from './List';
import WarningCreate from './Create';
import WarningDetail from './Detail';

const defaultFields = {
    Subject: { visible: false, label: '', required: false },
    BecameAwareDate: { visible: false, label: '', required: false },
    RiskItems: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    MeetingRequired: { visible: false, label: '', required: false },
    MeetingLocation: { visible: false, label: '', required: false },
    MeetingDate: { visible: false, label: '', required: false },
    MeetingTime: { visible: false, label: '', required: false },
    MeetingAttendees: { visible: false, label: '', required: false },
    Likelihood: { visible: false, label: '', required: false },
    Severity: { visible: false, label: '', required: false },
    Reference: { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false }
}
const defaultReplyFields = {
    NoReply: { visible: false, label: '', required: false },
    ReplyComment: { visible: false, label: '', required: false },
}


///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };
    fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    fields.BecameAwareDate = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.BECAME_AWARE"], required: true };

    if (resources.RiskItemsLabel) {
        fields.RiskItems = { visible: true, label: resources.RiskItemsLabel, required: true };

        //USE RiskTypesSupplier for Supplier if exist
        if (wfid === 2 && placeholdersQA.RiskTypesSupplier) {
            fields.RiskItems.riskTypes = placeholdersQA.RiskTypesSupplier.values.filter(riskItem => riskItem.isActive === true);
        }
        //USE RiskTypesClient for CLIENT if exist
        else if (wfid === 74 && placeholdersQA.RiskTypesClient) {
            fields.RiskItems.riskTypes = placeholdersQA.RiskTypesClient.values.filter(riskItem => riskItem.isActive === true);
        }
        //else use common RiskTypes
        else if (placeholdersQA.RiskTypes) {
            fields.RiskItems.riskTypes = placeholdersQA.RiskTypes.values.filter(riskItem => riskItem.isActive === true);
        }
    }

    if (resources.DescriptionLabel) {
        fields.Description = { visible: true, label: resources.DescriptionLabel, required: true };
    }
    if (resources.MeetingRequiredLabel) {
        fields.MeetingRequired = { visible: true, label: resources.MeetingRequiredLabel, required: true };
        fields.MeetingRequired.meetingOptions = placeholdersQA.MeetingOptions.values.filter(item => item.isActive === true).map(option => ({ ...option, field: Number(option.field) }));
    }
    fields.MeetingLocation = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.PROPOSED_LOC"], required: true };
    fields.MeetingDate = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.PROPOSED_DATE"], required: true };
    fields.MeetingTime = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.PROPOSED_TIME"], required: true };
    fields.MeetingAttendees = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.PROPOSED_ATTENDEE"], required: true };


    let riskOptions = [
        { value: "Very Low", effect: 1, display: languageFile['OPTIONS.RISK.Very Low']  },
        { value: "Low", effect: 2, display: languageFile['OPTIONS.RISK.Low'] },
        { value: "Medium", effect: 3, display: languageFile['OPTIONS.RISK.Medium'] },
        { value: "High", effect: 4, display: languageFile['OPTIONS.RISK.High'] },
        { value: "Very High", effect: 5, display: languageFile['OPTIONS.RISK.Very High'] },
    ];
    fields.Likelihood = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.LIKELIHOOD"], required: true };
    fields.Likelihood.riskOptions = riskOptions;
    fields.Severity = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.SEVERITY"], required: true };
    fields.Severity.riskOptions = riskOptions;
    fields.Reference = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.PRIORITY"], required: true };
    fields.Reference.riskOptions = riskOptions;

    const workflowItem = workflowsQA[wfid];
    let clauses = workflowItem.clauses;

    fields.Type.clauses = clauses;

    return fields;
}

///ALL REPLY FIELDS ARE DECIDED WITHIN THE getReplyFields FUNCTION
///THE getReplyFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign replyFields to workflowItem
export const getReplyFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid) => {
    const replyFields = { ...defaultReplyFields };
    replyFields.NoReply = { visible: true, label: languageFile["CONTRACT.WF.EW.FIELD.NO_REPLY"], required: true };
    replyFields.ReplyComment = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.COMMENTS"], required: true };
    return replyFields;
}

class EarlyWarningRouter extends React.Component {
    constructor(props) {
        super(props);

        if (props.mode === 'SUPPLIER') {
            this.documentType = 'Document161CON';
        }
        else if (props.mode === 'PM') {
            this.documentType = 'Document161PM';
        }
        else if (props.mode === 'CLIENT') {
            this.documentType = 'Document161CLI';
        }

        this.replyingParty = props.workflowItem.replyingParty;


        this.replyPeriod = props.workflowItem.replyPeriod;
        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;

        ////////////////////////////////////////////////////////////////////////////
        this.riskStatusOptions = [];
        if (props.placeholdersQA.RiskStatusOptions) {
            this.riskStatusOptions = props.placeholdersQA.RiskStatusOptions.values.filter(item => item.isActive === true);
        }
        ////////////////////////////////////////////////////////////////////////////


    }
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;
        return (
            <Routes caseSensitive>
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<WarningList
                        {...this.props}
                        replyPeriod={this.replyPeriod}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}
                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <WarningCreate
                                {...this.props}
                                replyPeriod={this.replyPeriod}
                                title={this.notificationName}
                                abbreviation={this.abbreviation}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    exact
                    element={
                        <WarningDetail
                            {...this.props}
                            replyPeriod={this.replyPeriod}
                            title={this.notificationName}
                            abbreviation={this.abbreviation}
                            documentType={this.documentType}
                            riskStatusOptions={this.riskStatusOptions}
                        />
                    }
                />
            </Routes>
        );
    }
};




export default (EarlyWarningRouter);